import React, { Fragment, useState,useEffect } from "react";
import { useForm } from "react-hook-form";
import { Row, Col, Form, Label, FormGroup, Button, Input } from "reactstrap";
import RequiredField, { Submit, Cancel} from "../../../Constant";
import { Breadcrumbs } from "../../../AbstractElements";
import { useLocation, useNavigate } from "react-router";
import { toast } from 'react-toastify';
import SweetAlert from 'sweetalert2';
import { CreatePharmacy, PharmacyCategoryList, UpdatePharmacy } from "../../../apiController";


const PharmacyForm = ({ setSteps }) => {
  const navigate = useNavigate()

  const location = useLocation();

  const { rowData } = location.state || {};

  const [formdata, setFormdata] = useState({ pharmacycategory: rowData?.category_id});
  const [category, setCategory] = useState([]);

 

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset, 
    setValue
  } = useForm({defaultValue: { pharmacycategory: rowData?.category_id}});

  if(rowData){
    setValue('pharmacycategory', rowData?.category_id)
  }

  const onSubmit = async (data) => {
    console.log(data)
    setFormdata((prev) => ({ ...prev, ...data }));
    // setSteps((prev) => prev + 1);
    const formattedData = {
      category_id: data.pharmacycategory,
      sub_name: data.medicinename,
      available_stock: data.stockquantity,
      price:data.price,
      id: rowData? rowData.id : ""
    }

    console.warn(formattedData)

    try {
      if (rowData) {
          const response = await UpdatePharmacy(formattedData);
          if (response.status === true) {
              toast.success('Updated Successfully!', { position: toast.POSITION.TOP_CENTER });
          }
          navigate(`${process.env.PUBLIC_URL}/pharmacy/:layout>}`)
      } else {
          const response = await CreatePharmacy(formattedData);
          if (response.status === true) {
              toast.success('Created Successfully!', { position: toast.POSITION.TOP_CENTER });
              
          }
          navigate(`${process.env.PUBLIC_URL}/pharmacy/:layout>}`)
      }
  } catch (error) {
      toast.error('An error occurred!', { position: toast.POSITION.TOP_CENTER });
  }
    reset()
    
  };

  const fetchPharmacyCategory = async () => {
    const response = await PharmacyCategoryList();
    if (response.status === true) {
      setCategory(response.data);
    }
  };

  useEffect(()=>{
    fetchPharmacyCategory()
  },[])
console.warn(formdata.pharmacycategory)
  return (
    <Fragment>
      <Breadcrumbs parent="Pharmacy" mainTitle="Pharmacy Form" title="Pharmacy Form" />
          <Form onSubmit={handleSubmit(onSubmit)} className="form-bookmark needs-validation">
          <Row>
            <Col sm="1" lg="2" xl="3"></Col>
            <Col sm="10" lg="8" xl="6" className="custom-padding-lg">
                <FormGroup className="mb-3">
                      <Label htmlFor="exampleFormControlSelect9">{"Pharmacy Category"} <RequiredField/></Label>
                          <select name="pharmacycategory" className="form-control digits" id="pharmacycategory" value={formdata.pharmacycategory}  {...register("pharmacycategory", { required: true })}>
                              <option  value=''>Select Pharmacy Category</option>
                                 {category.map((type)=> <option key={type.id} value={type.id}>{type.name}</option>)}
                          </select>
                        <span className="text-danger">{errors.pharmacycategory && "Pharmacy Category is required"}</span>
                  </FormGroup>
            <FormGroup className="mb-3">
              <Label htmlFor="fname">{"Medicine Name"} <RequiredField/></Label>
              <input className={`form-control ${errors.medicinename && "is-invalid"}`} id="medicinename" type="text" name="medicinename" defaultValue={formdata.sub_name || rowData?  rowData.sub_name : "" } {...register("medicinename", { required: true })} />
              <span className="text-danger">{errors.medicinename && "Medicine Name is required"}</span>
            </FormGroup>
            <FormGroup className="mb-3">
              <Label htmlFor="mobilenumber">{"Stock Quantity"} <RequiredField/></Label>
              <input className={`form-control ${errors.stockquantity && "is-invalid"}`} id="stockquantity" type="number" name="stockquantity" defaultValue={formdata.available_stock || rowData? rowData.available_stock : ""} {...register("stockquantity", { required: true })} />
              <span className="text-danger">{errors.stockquantity && "Stock Quantity is required"}</span>
            </FormGroup>
            <FormGroup className="mb-3">
              <Label htmlFor="age">{"Price"}<RequiredField/></Label>
              <input className={`form-control ${errors.price && "is-invalid"}`} id="price" type="number" name="price" defaultValue={formdata.fee ||  rowData ?  rowData.price : "" } {...register("price", { required: true })} />
              <span className="text-danger">{errors.age && "Price is required"}</span>
            </FormGroup>  
            <div className="text-end btn-mb mt-5">
              <Button className="secondary me-2" onClick={()=> navigate(`${process.env.PUBLIC_URL}/pharmacy/:layout>}`)}>
                {Cancel}
              </Button>
            <Button className="primary" type="submit">
                {Submit}
              </Button>
            </div>                              
            </Col>
            <Col sm="1" lg="2" xl="3"></Col>
      </Row>
          </Form>
    </Fragment>
  );
};

export default PharmacyForm;
